// extracted by mini-css-extract-plugin
export default {"container":"teams_container__cqbno","actions":"teams_actions__iR4bq"};